import { DataBean } from "../DataBean";

export class TransportServiceType extends DataBean {



    public async getTransportServiceType(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTransportServiceType_Number", [args]);
    }

}